let listener = null;

export const registerToast = (callback) => {
    listener = callback;
};

export const showToast = (message, variant = "success") => {
    if (listener) {
        listener(message, variant);
    }
};